/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmittedJob } from './SubmittedJob';
import type { ThermalModelDetails } from './ThermalModelDetails';
/**
 * Motor Loss Map ID. Data referenced by ID.
 */
export type MotorLossMapID = {
    item_type?: MotorLossMapID.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    _id?: string;
    data_id?: (string | null);
    submitted_job?: (SubmittedJob | null);
    thermal_model_details?: ThermalModelDetails;
    poles?: number;
    voltages?: Array<number>;
    component_type?: 'MotorLossMapID';
};
export namespace MotorLossMapID {
    export enum item_type {
        COMPONENT = 'component',
    }
}

